import * as React from "react";
import { useTranslation } from "react-i18next";
import { DocumentTitle } from "components/common";
import { Alert, Row, Col } from "components/bootstrap";
import PageHeader from "components/common/PageHeader";
import PageContentLayout from "components/layout/PageContentLayout";
const UserHasNoStreamAccess = () => {
  const { t } = useTranslation("streams");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("user_no_stream_access.title") }, /* @__PURE__ */ React.createElement(PageContentLayout, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("user_no_stream_access.title") }), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("user_no_stream_access.alert"))))));
};
export default UserHasNoStreamAccess;
